export default __webpack_public_path__ + "static/media/RESIDENTIAL-HOT-MOP.cc42e50b.jpg";